import { GET_REPORT_CONFIGURATION } from "../../../../config/constants";
import { withType } from "../../../utils/actionOperations";
import { ApiBase } from "../../../utils/apiBase";
import { getProjectIdAndOrgId } from "../../../utils/apiUtils";
import {
  RENDER_PDF_LOAD_STARTED,
  RENDER_PDF_LOAD_SUCCESS,
  RENDER_PDF_LOAD_FAILED,
} from "../../constants";

export const loadReportData = (payload) => {
  const apiBaseInstance = new ApiBase();
  return (dispatch) => {
    dispatch(withType(RENDER_PDF_LOAD_STARTED, {}));
    apiBaseInstance.instance.post(GET_REPORT_CONFIGURATION, { ...getProjectIdAndOrgId(payload) }).then((stored) => {
        dispatch(withType(RENDER_PDF_LOAD_SUCCESS, { data: stored }));
      })
      .catch((err) => {
        dispatch(withType(RENDER_PDF_LOAD_FAILED, { error: err }));
      });
  };
};
